<template lang="pug">
  v-layout.box-main-mis-seguros-mobile-formatter(row style="position:relative")
    PopupAlertMessage(
      @closeAlertPopup="closeAlertMethod"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
        )
    //-PopupAniversario(
      :openPopup="flagOpenAniversario"
      )
    //- LOADER PROCESS
    v-dialog(v-model="loader.flag" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | {{loader.text}}
          v-progress-linear.mb-0(indeterminate="" color="white")
    PopupCoberturas(
      v-if="flagOpenCobertura"
      @closePopup="methodView"
      :openPopup="flagOpenCobertura"
      :coberturas="poliza.coberturasVida"
      :tipoMoneda="poliza.tipoMoneda"
      :poliza="poliza"
      :taggeo="taggeo"
      )
    PopupMisSolicitudes(
      v-if="flagOpenMisSolicitudes"
      @closePopup="methodView"
      @goToPlan="methodView"
      :openPopup="flagOpenMisSolicitudes"
      :mas2Anhos="mas2Anhos"
      :puedeEndosar="poliza.puedeEndosar"
      :puedeCuotaComodin="poliza.puedeCuotaComodin"
      :puedeCambiarFrecuencia="poliza.puedeCambiarFrecuencia"
      :puedeLiberarEndoso="poliza.puedeLiberarEndoso"
      :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
      :puedeRetirarCoberturas="poliza.puedeRetirarCoberturas"
      :poliza="poliza"
      :taggeo="taggeo"
      :solicitudBeneficiarios="solicitudBeneficiarios"
      :solicitudComodin="solicitudComodin"
      :solicitudEndosoEntidadFinanciera="solicitudEndosoEntidadFinanciera"
      :solicitudLiberacionEndoso="solicitudLiberacionEndoso"
      :solicitudAnulacion="solicitudAnulacion"
      :solicitudSeguimiento="solicitudSeguimiento"
      :action="noActionSend ? null : action"
    )
    PopupComprobanteElectronico(
      v-if="flagOpenComprobante"
      @closePopup="methodView"
      :openPopup="flagOpenComprobante"
      :iconDescarga="iconDescargaComprobante"
      :listaDeComprobantes="listComprobantesElectronicos"
      :poliza="poliza"
      :taggeo="taggeo"
      )
    PopupDocumentosEndoso(
      v-if="flagOpenDocumentosEndoso"
      @closePopup="methodView"
      :openPopup="flagOpenDocumentosEndoso"
      :taggeo="taggeo"
      :documentos="documentosEndosoDisponibles"
      :id="requerimientoId"
    )
    PopupMisBeneficiarios(
      v-if="flagOpenMisBeneficiarios"
      @closePopup="methodView"
      :openPopup="flagOpenMisBeneficiarios"
      :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
      :beneficiariosPrincipales="beneficiariosPrincipalesProp"
      :beneficiariosContingentes="beneficiariosContingentesProp"
      :poliza="poliza"
      :taggeo="taggeo"
      )
    PopupHoy(
      v-if="flagHoyView1"
      @closePopup="methodView"
      :openPopup="flagHoyView1"
      :periodos="(flagIsVidacash || flagIsRumbo) ? poliza.tablaDevoluciones : poliza.tablaValoresGarantizados"
      :tipoMoneda="poliza.tipoMoneda"
      :inicioVigencia="poliza.fechaVigencia"
      :finVigencia="poliza.fechaFinVigencia"
      :pagoHasta="poliza.pagadoHasta"
      :totalPagoEfectuado="totalPagosEfectuados"
      :taggeo="taggeo"
      )
    PopupHoyHasta5(
      v-if="flagHoyView2"
      @closePopup="methodView"
      :openPopup="flagHoyView2"
      :periodos="(flagIsVidacash || flagIsRumbo) ? hoy : poliza.tablaValoresGarantizados"
      :periodoDePago="poliza.periodoDePago"
      :tipoMoneda="poliza.tipoMoneda"
      :inicioVigencia="poliza.fechaVigencia"
      :finVigencia="poliza.fechaFinVigencia"
      :pagoHasta="poliza.pagadoHasta"
      :montoAsegurado="(flagIsVidacash || flagIsRumbo) ? setFormatNumber(poliza.montoDevolucion) : poliza.montoAsegurado"
      :cuota="poliza.montoCuota"
      :netoAnual="calculoPagoAnual"
      :totalPagoEfectuado="totalPagosEfectuados"
      :producto="poliza.oriProducto"
      :nombreProducto="poliza.nombreProducto"
      :taggeo="taggeo"
      :suenio="(poliza.informacionExtra || {}).suenio"
      )
    PopupProyeccion(
      v-if="flagProyeccion"
      @closePopup="methodView"
      :openPopup="flagProyeccion"
      :montoAsegurado="(flagIsVidacash || flagIsRumbo) ? setFormatNumber(poliza.montoDevolucion) : poliza.montoAsegurado"
      :periodoDePago="poliza.periodoDePago"
      :tipoMoneda="poliza.tipoMoneda"
      :periodos="(flagIsVidacash || flagIsRumbo) ? poliza.tablaDevoluciones : poliza.tablaValoresGarantizados"
      :inicioVigencia="poliza.fechaVigencia"
      :taggeo="taggeo"
      :numeroPoliza="poliza.numeroPoliza"
      :producto="poliza.nombreProducto"
      :oriProducto="poliza.oriProducto || ''"
      )
    PopupBeneficiosDesbloqueados(
      v-if="flagBeneficiosDesbloqueados"
      @closePopup="methodView"
      :openPopup="flagBeneficiosDesbloqueados"
      :mas2Anhos="mas2Anhos"
      :poliza="poliza"
      :solicitudBeneficiarios="solicitudBeneficiarios"
      :solicitudComodin="solicitudComodin"
      :solicitudEndosoEntidadFinanciera="solicitudEndosoEntidadFinanciera"
      :solicitudLiberacionEndoso="solicitudLiberacionEndoso"
      :solicitudAnulacion="solicitudAnulacion"
      :solicitudSeguimiento="solicitudSeguimiento"
      :puedeEndosar="poliza.puedeEndosar"
      :puedeCuotaComodin="poliza.puedeCuotaComodin"
      :puedeCambiarFrecuencia="poliza.puedeCambiarFrecuencia"
      :puedeLiberarEndoso="poliza.puedeLiberarEndoso"
      :puedeCambiarBeneficiario="poliza.puedeCambiarBeneficiario"
    )
    PopupMisVales(
      v-if="flagMisVales"
      @closePopup="methodView"
      :openPopup="flagMisVales"
      :poliza="poliza"
      :taggeo="taggeo"
    )
    v-flex.box-open-guia-seguros
      v-btn(@click="methodView('guia')"  dark fab)
        img(style="height:60px !important" :src="iconPrueba")
    v-flex
      TooltipGuiaMisSeguros(
        style="position:absolute;z-index: 1;left: calc(50% - 170px);top: 149px;box-shadow: 0px 0px 50px -15px;"
        @closePopup="closeTooltip"
        :openPopup="flagOpenTooltipMisSeguros"
        :producto="infoPoliza.nombreProducto"
        :oriProducto="poliza.oriProducto || ''"
        )
    v-flex
      v-layout(column style="padding: 0 15px;margin-top:14px")
        v-flex
          v-layout.box-mis-seguros(column)
            v-flex.box-title-main-formatter
              span.title-name
                b Hola {{ usuario.titleName }},
            v-flex.box-text-main-formatter(style="line-height: normal;")
              span(style="color:#454A6C; font-size:18px") Estos son los datos de tu seguro&nbsp;
                b {{ this.setProductName() }}
        v-flex(style="margin: 1em 0em")
          v-layout(row :class="{ 'box-buttons-centered': flagOcultarProyeccion }")
            v-flex
              ButtonSelect(
                :textBottunProp="'Plan'"
                :activar="flagPlan"
                @selectButton="methodView"
                )
            v-flex
              ButtonSelect(
                :textBottunProp="'Hoy'"
                :activar="flagHoy"
                @selectButton="methodView"
                )
            v-flex(v-if="!flagOcultarProyeccion")
              ButtonSelect(
                :textBottunProp="'Proyección'"
                :activar="flagProyeccion"
                @selectButton="methodView"
                )
        v-flex(style="margin-bottom: 11px;")
          v-layout.box-monto-asegurado-formatter(column align-center)
            v-flex(style="margin: 0.5em 0em")
              span(style="font-family: 'Omnes Medium';color: #454A6C;font-size: 18px;") {{ flagIsVidacash ? 'Monto Protección Principal' : 'Monto Asegurado'}}
            v-flex(style="margin-bottom: 1em")
              IconText(
                :iconMoney="iconMoneyMontoAsegurado"
                :typeMoney="poliza.tipoMoneda"
                :textMoney="poliza.montoAsegurado")
            v-flex
              v-layout.box-card-periodo-cuota-formatter(row justify-center)
                v-flex(xs4)
                  CardNumberText(
                    :textNumber="poliza.periodoDePago + ' '+ (poliza.periodoDePago>1 ? 'años' : 'año')"
                    :description="'Periodo de pago'")
                v-flex(xs4)
                  CardNumberText(
                    :textNumber="flagIsVidacash ? poliza.primaProgramada : poliza.montoCuota"
                    :description="'Cuota '+ poliza.frecuenciaPago")
                v-flex(xs4 @click="methodView('coberturas')")
                  CardNumberText(
                    :textNumber="poliza.coberturasVida ? poliza.coberturasVida.length : 0"
                    :description="'Ver Coberturas'"
                    :cardBackgroundColor="'#EA0D90'")
          v-flex(v-if="flagIsVidacash || flagIsRumbo")
            CardIconTextDoubleRow(
              :icon="iconDevolucion"
              :text="poliza.tipoMoneda+new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(poliza.montoDevolucion)"
              :detail="Number(poliza.porcentajeDevolucion)*100"
              :textTooltip="'Dinero que voy a recibir al término de mi periodo de pago.'"
              :ocultarMonto="flagOcultarProyeccion"
            )
        v-flex.home-line
        v-flex
          v-layout.box-menu-mis-seguros(column)
            v-flex.box-menu-formatter.box-datos-mis-seguros(@click="desplegarDatosMiSeguro(flagMiSeguro)")
              IconTextIcon(:textProp="'Datos de mi seguro'" :iconTextProp="iconMisDatos" :iconFlagProp="iconlistFlag")
            v-flex.box-menu-formatters(v-if="flagMiSeguro")
              DatosMisSeguros(
                @datosMisSegurosMethod="getPDFElectronicPolicy"
                :numeroPoliza="poliza.numeroPoliza"
                :inicioFinVigencia="poliza.fechaVigencia+ ' - '+poliza.fechaFinVigencia"
                :periodoDePago="poliza.periodoDePago + ' '+ (poliza.periodoDePago>1 ? 'años' : 'año')"
                :periodoDeCobertura="poliza.periodoDeCobertura + ' '+ (poliza.periodoDeCobertura>1 ? 'años' : 'año')"
                :montoAsegurado="flagIsVidacash ? setFormatNumber(poliza.montoDevolucion) : poliza.montoAsegurado"
                :cuota="(poliza.primaProgramadaMoneda=='NUEVO SOL' ? 'S/' : '$')+''+(flagIsVidacash ? poliza.primaProgramada : poliza.montoCuota)"
                :frecuenciaDePago="poliza.frecuenciaPago"
                :pagoHasta="poliza.pagadoHasta"
                :tipoMoneda="poliza.tipoMoneda"
                :taggeo="taggeo"
                :producto="poliza.nombreProducto"
                :oriProducto="poliza.oriProducto || ''"
                :hasDocument="!!poliza.codigoProceso && (poliza.codigoProceso || []).length > 0"
              )
            v-flex(v-show="flagMiSeguro" style="border-bottom: 9px solid rgb(222, 222, 222);position: relative;max-width: 140%;width: 140%;align-self: center;top:-2px")
            v-flex.box-menu-formatter(
              v-if="puedeSolicitudes"
              @click="methodView('solicitudes')"
              )
              IconTextIcon(:textProp="'Mis solicitudes'" :iconTextProp="iconMisSolicitudes" :iconFlagProp="iconlistFlag")
            v-flex.box-menu-formatter.box-mi-estado-de-cuenta(@click="desplegarEstadoDeCuenta(flagEstadoCuenta)")
              IconTextIcon(v-if="poliza.oriProducto !== 'VIDA_CASH_PLUS'" :textProp="'Mi estado de cuenta'" :iconTextProp="iconMiEstadoCuenta" :iconFlagProp="iconlistFlag")
              EstadoDeCuenta(
                v-if="flagEstadoCuenta"
                :poliza="poliza"
                :taggeo="taggeo"
                )
            v-flex(v-show="flagEstadoCuenta" style="border-bottom: 9px solid rgb(222, 222, 222);position: relative;max-width: 140%;width: 140%;align-self: center;top:-2px")
            v-flex.box-menu-formatter(v-if="documentosEndosoDisponibles.length > 0" @click="methodView('documentos de endoso')")
              IconTextIcon(:textProp="'Documentos de endoso'" :iconTextProp="iconComprobanteElectronico" :iconFlagProp="iconlistFlag")
            v-flex.box-menu-formatter(v-if="poliza.oriProducto !== 'VIDA_CASH_PLUS'" @click="methodView('comprobante')")
              IconTextIcon(:textProp="'Comprobante electrónico'" :iconTextProp="iconComprobanteElectronico" :iconFlagProp="iconlistFlag")
            v-flex.box-menu-formatter(v-if="(poliza.oriProducto || '').toLowerCase() !== 'endosos'" @click="methodView('beneficiarios')")
              IconTextIcon(:textProp="'Mis beneficiarios'" :iconTextProp="iconMisBeneficiarios" :iconFlagProp="iconlistFlag")
            v-flex.box-menu-formatter.box-mi-agente(v-if="poliza.nombreAgente" @click="desplegarAgente(flagAgente)")
              IconTextIcon(:textProp="'Mi agente'" :iconTextProp="iconMiAgente" :iconFlagProp="iconlistFlag")
              MiAgenteMobile(
                v-if="flagAgente"
                :nombre="poliza.nombreAgente"
                :correo="poliza.emailAgente"
                :celular="''"
                :taggeo="taggeo"
              )
            v-flex.box-menu-formatter.box-mis-canales(v-if="!poliza.nombreAgente" @click="desplegarCanales(flagMisCanales)")
              IconTextIcon(:textProp="'Mis canales de atención'" :iconTextProp="iconMisCanales" :iconFlagProp="iconlistFlag")
              MisCanales(
                v-if="flagMisCanales"
                :taggeo="taggeo"
              )
            v-flex.box-menu-formatter(
              v-if="!mayor5Anhos && !flagIsVidacash"
              @click="methodView('beneficios')"
              style="border-bottom:none"
              )
              IconTextIcon(
                :textProp="'Beneficios desbloqueados'"
                :iconTextProp="iconBeneficios"
                :iconTextPropHover="''"
                :iconFlagProp="iconlistFlag")
            v-flex.box-menu-formatter(
              v-if="flagIsVidacash"
              @click="methodView('vales')"
              style="border-bottom:none"
              )
              IconTextIcon(
                :textProp="'Mis vales'"
                :iconTextProp="iconBeneficios"
                :iconTextPropHover="''"
                :iconFlagProp="iconlistFlag")

</template>

<script>
import PopupMisVales from '@/components/mis-seguros/PopupMisVales.vue'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import CardIconTextDoubleRow from '../../components/generic/CardIconTextDoubleRow.vue'
import EstadoDeCuenta from '../../components/mis-seguros/EstadoDeCuenta.vue'
import MiAgenteMobile from '../../components/mis-seguros/MiAgenteMobile.vue'
import MisCanales from '../../components/mis-seguros/MisCanales.vue'
import PopupAniversario from '../../components/mis-seguros/PopupAniversario.vue'
import PopupBeneficiosDesbloqueados from '../../components/mis-seguros/PopupBeneficiosDesbloqueados.vue'
import PopupComprobanteElectronico from '../../components/mis-seguros/PopupComprobanteElectronico.vue'
import PopupDocumentosEndoso from '../../components/mis-seguros/PopupDocumentosEndoso.vue'
import PopupHoy from '../../components/mis-seguros/PopupHoy.vue'
import PopupHoyHasta5 from '../../components/mis-seguros/PopupHoyHasta5.vue'
import PopupMiAgente from '../../components/mis-seguros/PopupMiAgente.vue'
import PopupMisSolicitudes from '../../components/mis-seguros/PopupMisSolicitudes.vue'
import PopupProyeccion from '../../components/mis-seguros/PopupProyeccion.vue'
import TooltipGuiaMisSeguros from '../../components/mis-seguros/TooltipGuiaMisSeguros.vue'
import PopupAlertMessage from '../../components/PopupAlertMessage.vue'
import electronicVouchers from '../../interfaces/electronicVouchers'
import Functionalities from '../../interfaces/functionalities'
import paymentFrequency from '../../interfaces/paymentFrequency'
import Transacts from '../../interfaces/transacts'
import ButtonSelect from './../../components/generic/ButtonSelect.vue'
import CardNumberText from './../../components/generic/CardNumberText.vue'
import IconText from './../../components/generic/IconText.vue'
import IconTextIcon from './../../components/generic/IconTextIcon.vue'
import DatosMisSeguros from './../../components/mis-seguros/DatosMisSeguros.vue'
import PopupCoberturas from './../../components/mis-seguros/PopupCoberturas.vue'
import PopupMisBeneficiarios from './../../components/mis-seguros/PopupMisBeneficiarios.vue'

export default {
  props: [
    'infoPoliza',
    'infoUser',
    'action'
  ],
  data () {
    return {
      noActionSend: false,
      actionSent: false,
      title: '',
      icons: {
        cliente: require('./../../assets/vida-icons/icon-cliente.svg')
      },
      iconMoneyMontoAsegurado: require('./../../assets/icons-mis-seguros/icon-money.svg'),
      iconDevolucion: require('./../../assets/icons-mis-seguros/icon-devolucion.svg'),
      iconlistFlag: require('./../../assets/icons-mis-seguros/icon-round-navigate-next.svg'),
      iconMisDatos: require('./../../assets/icons-mis-seguros/icon-datos-mi-seguro.svg'),
      iconMisSolicitudes: require('./../../assets/icons-mis-seguros/icon-mis-solicitudes.svg'),
      iconMiEstadoCuenta: require('./../../assets/icons-mis-seguros/icono-mi-estado-cuenta.svg'),
      iconComprobanteElectronico: require('./../../assets/icons-mis-seguros/icon-comprobante-electrónico.svg'),
      iconMisBeneficiarios: require('./../../assets/icons-mis-seguros/icono-mis-beneficiarios.svg'),
      iconMiAgente: require('./../../assets/icons-mis-seguros/icono-mi-agente.svg'),
      iconMisCanales: require('./../../assets/icons-mis-seguros/icono-mis-canales.svg'),
      iconDescargaComprobante: require('./../../assets/icons-mis-seguros/icon-flag-down.svg'),
      iconPrueba: require('./../../assets/icons-mis-seguros/icon-onboarding1.svg'),
      iconAniversario: require('./../../assets/icons/gif-aniversario.gif'),
      iconBeneficios: require('./../../assets/icons/icon-nuevo.svg'),
      totalPagosEfectuados: 0,
      flagMiSeguro: false,
      flagEstadoCuenta: false,
      flagAgente: false,
      flagMisCanales: false,
      flagOpenCobertura: false,
      flagOpenComprobante: false,
      flagOpenDocumentosEndoso: false,
      documentosEndosoDisponibles: [],
      requerimientoId: null,
      flagOpenMisBeneficiarios: false,
      flagOpenMiAgente: false,
      flagOpenTooltipMisSeguros: false,
      flagHoyView1: false,
      flagHoyView2: false,
      flagOpenPlan: false,
      flagPlan: true,
      flagHoy: false,
      flagProyeccion: false,
      flagOpenMisSolicitudes: false,
      flagOpenAniversario: false,
      flagBeneficiosDesbloqueados: false,
      flagMisVales: false,
      flagIsVidacash: false,
      flagIsRumbo: false,
      listComrpobantesElectronicosActuales: [],
      listComprobantesElectronicos: [],
      items: [],
      ce: {
        maxDate: null,
        minDate: null,
        modalStart: false,
        modalEnd: false,
        startDate: null,
        endDate: null,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      beneficiariosPrincipalesProp: [],
      beneficiariosContingentesProp: [],
      misMetasPendientesProp: [],
      misMetasAlcanzadasProp: [],
      poliza: {},
      usuario: {},
      loader: {
        flag: false,
        text: 'Cargando la página...'
      },
      popupAlert: {
        openPopup: false,
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      hoy: [
        {
          anho: '02',
          lock: false
        }, {
          anho: '03',
          lock: false
        }, {
          anho: '04',
          lock: false
        }, {
          anho: '05',
          lock: false
        }
      ],
      cuotaPeriodo: 0,
      taggeo: {
        tipoDocumento: '',
        numeroDocumento: '',
        numeroPoliza: '',
        ramo: '',
        producto: '',
        nombreProducto: '',
        nombre: 'Mis Seguros - ' + ((this.infoPoliza.nombreProducto || '').includes('VIDACASH') ? 'VC' : 'PG'),
        antiguedad: 0
      },
      mayor5Anhos: false,
      mas2Anhos: false,
      solicitudBeneficiarios: [],
      solicitudComodin: [],
      solicitudEndosoEntidadFinanciera: [],
      solicitudLiberacionEndoso: [],
      solicitudAnulacion: [],
      solicitudSeguimiento: [],
      calculoPagoAnual: 0,
      selectedTypeDoc: null,
      puedeSolicitudes: false
    }
  },
  methods: {
    ...mapActions('user', ['getBenefits', 'getComprobantes', 'getPDFPolizaElectronica']),
    ...mapActions('requirements', ['getAllRequirementsPerPolicy', 'filterPolicyRequirements']),
    ...mapActions('endorsements', ['getDocsEndorsement']),
    ...mapActions('event', ['eventLog']),
    setProductName () {
      if (this.flagIsRumbo) {
        return 'Rumbo'
      }
      return this.flagIsVidacash ? 'Vida con Devolución' : this.poliza.oriProducto
    },
    setFormatNumber (number) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number)
    },
    desplegarDatosMiSeguro (flag) {
      this.flagMiSeguro = (!flag)
      const icon = document.querySelector('.box-datos-mis-seguros .icon-flag')
      icon.classList.toggle('icon-rotate')
    },
    desplegarEstadoDeCuenta (flag) {
      this.flagEstadoCuenta = (!flag)
      const icon = document.querySelector('.box-mi-estado-de-cuenta .icon-flag')
      icon.classList.toggle('icon-rotate')
    },
    desplegarAgente (flag) {
      this.flagAgente = (!flag)
      const icon = document.querySelector('.box-mi-agente .icon-flag')
      icon.classList.toggle('icon-rotate')
    },
    desplegarCanales (flag) {
      this.flagMisCanales = (!flag)
      const icon = document.querySelector('.box-mis-canales .icon-flag')
      icon.classList.toggle('icon-rotate')
    },
    methodView (item) {
      let self = this
      const nombreProducto = this.poliza.nombreProducto || this.poliza.producto
      if (item === 'comprobante' && !Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.actionSent) {
        this.noActionSend = true
      }
      this.flagProyeccion = item === 'proyección'
      this.flagOpenTooltipMisSeguros = item === 'guia'
      this.flagHoy = item === 'hoy'
      this.flagOpenPlan = item === 'plan' || item === undefined
      this.flagOpenMisSolicitudes = item === 'solicitudes'
      this.flagOpenDocumentosEndoso = item === 'documentos de endoso'
      this.flagOpenCobertura = item === 'coberturas'
      this.flagOpenMisBeneficiarios = item === 'beneficiarios'
      this.flagOpenComprobante = item === 'comprobante'
      this.flagBeneficiosDesbloqueados = item === 'beneficios'
      this.flagMisVales = item === 'vales'
      this.flagHoyView1 = false
      this.flagHoyView2 = false
      this.flagMiSeguro = false
      this.flagEstadoCuenta = false
      this.flagAgente = false
      this.flagMisCanales = false

      // //    SOLICITUDE
      //     if (flagOrigen.flag && flagOrigen.origen == 'solicitudes') {
      //       this.popupAlert.openPopup = true
      //       this.popupAlert.messageButton = "Entendido"
      //       this.popupAlert.message = "No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos."
      //     }

      // HOY
      if (this.flagHoy) {
        let inicioVigencia = this.poliza.fechaVigencia.split(/[/-]/)
        let hoy = new Date()
        let auxInicioVigencia = new Date(Number(inicioVigencia[2]), (Number(inicioVigencia[1]) - 1), Number(inicioVigencia[0]))
        let auxlimit = this.getDiferenciaAnhos(hoy, auxInicioVigencia)

        if (!this.flagIsVidacash) {
          if (this.poliza.tablaValoresGarantizados.length <= 0) {
            this.popupAlert.openPopup = true
            this.popupAlert.image = require('@/assets/characters/informa.svg')
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.message = 'No hemos encontrado la información'
            this.popupAlert.messageButton = 'Entendido'
            self.methodView('mis seguros')
          } else if (auxlimit > 5) {
            this.flagHoyView1 = true
          } else {
            this.flagHoyView2 = true
          }
        } else {
          this.flagHoyView1 = auxlimit > 5
          this.flagHoyView2 = auxlimit <= 5
        }

        if (this.poliza.oriProducto === 'VIDA CON DEVOLUCIÓN PLUS') {
          this.popupAlert.openPopup = true
          this.popupAlert.image = require('@/assets/characters/informa.svg')
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = 'Por el momento no se encuentra activa esta funcionalidad.'
          this.popupAlert.messageButton = 'Entendido'
          this.popupAlert.buttonClose = false
          this.flagHoy = false
          this.flagHoyView1 = false
          this.flagHoyView2 = false
          return
        }
      }

      // PROYECCION - VALIDAR PAGO AL DIA
      if (this.flagProyeccion) {
        let today = new Date()

        let pagadoHasta = this.poliza.pagadoHasta.split(/[/-]/)
        let auxPagadoHasta = new Date(Number(pagadoHasta[2]), Number(pagadoHasta[1]) - 1, Number(pagadoHasta[0]))

        if (today > auxPagadoHasta) {
          this.popupAlert.openPopup = true
          this.popupAlert.image = require('@/assets/characters/informa.svg')
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = 'Aún cuenta con cuotas pendientes de pago'
          this.popupAlert.messageButton = 'Pago de cuotas'
          this.popupAlert.buttonClose = true

          this.eventLog({
            'tipoDocumento': self.taggeo.tipoDocumento,
            'numeroDocumento': self.taggeo.numeroDocumento,
            'categoria': 'Consulta',
            'nombre': self.taggeo.nombre,
            'datos': {
              'numeroPoliza': self.taggeo.numeroPoliza,
              'cuotas_Pendientes': 'SI',
              'antiguedad': self.periodoActual === undefined ? '01' : self.periodoActual.anho,
              'proyecciones': 0,
              'grupoProducto': self.taggeo.ramo,
              'producto': self.taggeo.nombreProducto,
              'navegacion': 'Proyección',
              'dispositivo': 'mobile'
            }
          })
        }
      }

      // COMPROBANTES
      if (this.flagOpenComprobante && this.poliza.oriProducto !== 'VIDA_CASH_PLUS') {
        if (this.listComrpobantesElectronicosActuales.length > 0) {
          self.showComprobantesElectronicos()
        } else {
          self.popupAlert.openPopup = true
          self.popupAlert.title = 'Estimado cliente'
          self.popupAlert.message = 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.' // 'No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos.'
          self.popupAlert.messageButton = 'Entendido'
          self.popupAlert.buttonClose = false
        }
      }
      this.loader.flag = false

      const boxIcon = document.querySelectorAll('.box-main-mis-seguros-mobile-formatter .box-menu-formatter .icon-flag')
      boxIcon.forEach(element => {
        element.classList.remove('icon-rotate')
      })
    },
    goToHome () {
      this.$router.push('/inicio')
    },
    periodoDePagoMethod (inicio, fin) {
      let inicioVigencia = inicio.split(/[/-]/)
      let finVigencia = fin.split(/[/-]/)

      let auxInicio = new Date(inicioVigencia[2], (inicioVigencia[1] - 1), inicioVigencia[0])
      let auxFin = new Date(finVigencia[2], (finVigencia[1] - 1), finVigencia[0])

      let periodoDePago = auxFin.getTime() - auxInicio.getTime()

      let aniosTotales = periodoDePago / (1000 * 3600 * 24 * 365)

      return Math.floor(aniosTotales)
    },
    formatMoneyMethod () {
      let tipoMoneda = (this.poliza.primaProgramadaMoneda === 'NUEVO SOL' ? 'S/' : '$')
      let montoAsegurado = parseFloat(this.poliza.montoCoberturaPrincipal).toLocaleString('en-US') // new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this.poliza.montoCoberturaPrincipal)
      let montoCuota = parseFloat(this.flagIsVidacash ? this.poliza.primaProgramada : this.poliza.netoPago).toLocaleString('en-US') // new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(this.poliza.netoPago)
      this.poliza.montoAsegurado = montoAsegurado
      this.poliza.montoCuota = montoCuota
      this.poliza.tipoMoneda = tipoMoneda
      this.totalPagosEfectuados = parseFloat(this.poliza.totalPagosEfectuados).toLocaleString('en-US')
    },
    async getPDFElectronicPolicy () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.DESCARGA_POLIZA, self.functionsRules, self, self.poliza.producto)) {
        return
      }
      this.loader.flag = true
      this.loader.text = 'Descargando Póliza...'
      await this.getPdfPoliza({numPoliza: this.poliza.numeroPoliza, makeDownload: true}, this.poliza.codigoProceso)
    },
    async getPdfPoliza (data, codigosProceso) {
      const self = this
      const metadata = []
      let downloaded = false
      for (let x = 0; x < codigosProceso.length && !downloaded; x++) {
        try {
          const res = await this.getPDFPolizaElectronica({...data, codProceso: codigosProceso[x]})
          if (res.status === 204) {
            this.loader.flag = false
            metadata.push({status: res.status, codigo: codigosProceso[x]})
            if (x === codigosProceso.length - 1) {
              this.loader.flag = false
              self.popupAlert.openPopup = true
              self.popupAlert.image = require('@/assets/characters/informa.svg')
              self.popupAlert.title = 'Comunicado'
              self.popupAlert.message = 'Lamentamos las molestias, esta póliza aún no está disponible en formato electrónico. Estamos trabajando para ofrecerla lo antes posible.'
              self.popupAlert.messageButton = 'Entendido'
            }
          } else {
            this.loader.flag = false
            downloaded = true
          }
        } catch (error) {
          metadata.push({ error: error.response, codProceso: codigosProceso[x] })
          if (x === codigosProceso.length - 1) {
            this.loader.flag = false
            self.popupAlert.openPopup = true
            self.popupAlert.image = require('@/assets/characters/informa.svg')
            self.popupAlert.title = 'Comunicado'
            self.popupAlert.message = 'No podemos realizar la descarga. Intente nuevamente en unos minutos o contáctese con servicio de atención al cliente.'
            self.popupAlert.messageButton = 'Entendido'
          }
        }

        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de póliza',
            metadata: {
              error: metadata.length > 0 ? { response: metadata } : undefined,
              numeroPoliza: self.taggeo.numeroPoliza,
              productoConsultado: self.taggeo.ramo,
              subproductoConsultado: self.taggeo.nombreProducto
            }
          })
        }, 3000)
      }
    },
    showComprobantesElectronicos () {
      let self = this
      const nombreProducto = this.poliza.nombreProducto || this.poliza.producto
      if (!Functionalities.isAvailable(Functionalities.vida.COMPROBANTES, self.functionsRules, self, nombreProducto)) {
        return
      }
      if (this.listComrpobantesElectronicosActuales.length < 1) {
        this.errorModalComprobantes = true
      }

      if (self.ce.startDate !== null && self.ce.endDate !== null) {
        this.loader.flag = true
        // LIMPIANDO LOS COMPROBANTES
        this.listComprobantesElectronicos = []
        let startDate = moment(self.ce.startDate + '-01')
        let endDate = moment(self.ce.endDate + '-01').endOf('month')
        // CONDICIONAL PARA CUBRIR TODOS LOS COMPROBANTES
        if (this.listComrpobantesElectronicosActuales.length > 0) {
          let documents = this.listComrpobantesElectronicosActuales
          // POBLANDO LOS COMPROBANTES
          for (let index = 0; index < documents.length; index++) {
            let fechaEmision = moment(documents[index].fechaEmision)
            if (fechaEmision.isBetween(startDate, endDate)) {
              let fechaEmisionFormat = moment(documents[index].fechaEmision, 'YYYY-MM-DD').locale('es').format('MMM-YYYY').replace('.', '')
              fechaEmisionFormat = fechaEmisionFormat.charAt(0).toUpperCase() + fechaEmisionFormat.slice(1)
              let hash = {
                fechaEmision: fechaEmisionFormat,
                tipoDocumento: documents[index].tipoComprobante,
                serie: documents[index].serie,
                correlativo: documents[index].numero,
                historico: false
              }
              this.listComprobantesElectronicos.push(hash)
            }
          }
        }
      } else {
        self.popupAlert.openPopup = true
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.messageButton = 'Entendido'
        self.popupAlert.image = require('@/assets/characters/informa.svg')
        self.popupAlert.message = 'No podemos realizar la descarga. Intente nuevamente en unos minutos o contáctese con servicio de atención al cliente.'
        // self.$swal({
        //   title: 'Estimado cliente',
        //   text: 'Debe completar la información para buscar sus comprobantes electrónicos.',
        //   type: 'info',
        //   showCancelButton: false,
        //   confirmButtonColor: '#2177CC',
        //   confirmButtonText: 'Entendido'
        // })
      }
    },
    closeTooltip () {
      localStorage.setItem('closeTooltip', false)
      this.flagOpenTooltipMisSeguros = false
    },
    closeAlertMethod (item) {
      if (this.flagProyeccion && item) {
        this.$router.push('/pago-de-cuotas')
      } else if (this.flagHoy && item) {
        this.methodView('hoy')
      } else {
        this.methodView('plan')
      }
      this.popupAlert.openPopup = false
      this.loader.flag = false
    },
    getDiferenciaAnhos (date1, date2) {
      let diferencia = (date2.getTime() - date1.getTime()) / 1000 / (3600 * 24)
      return Math.abs(Math.round(diferencia / 365.25))
    },
    consultarDocumentosEndoso (numeroPoliza, flagCesionada) {
      const self = this
      const params = {
        numeroPoliza: numeroPoliza
      }
      
      self.getAllRequirementsPerPolicy(params).then(res => {
        if (res.data.success && res.data.data.length > 0) {
          self.documentosEndosoDisponibles = res.data.data.flatMap(req =>
            (req.req_files || []).map(file => ({
              ...file,
              state: req.state
            }))
          )
        } else {
          self.documentosEndosoDisponibles = []
        }
      }).catch(() => {
        self.documentosEndosoDisponibles = []
      })
    }

  },
  created () {
    if ((this.infoPoliza.nombreProducto || '').includes('VIDACASH')) {
      this.flagIsVidacash = true
    } else {
      this.flagIsVidacash = false
    }
    
    this.flagIsRumbo = (this.infoPoliza.oriProducto || '').toLowerCase() === Transacts.products.RUMBO
  },
  mounted () {
    let self = this

    // CARGANDO DATA
    this.loader.flag = true

    if (self.infoPoliza) {
      self.poliza = self.infoPoliza
      self.usuario = self.infoUser
      self.poliza.periodoDePago = self.periodoDePagoMethod(self.poliza.fechaVigencia, self.poliza.fechaFinVigencia)
      if (this.poliza.oriProducto === 'VIDA_CASH_PLUS' || this.poliza.oriProducto === 'VIDA CON DEVOLUCIÓN PLUS') {
        this.poliza.periodoDePago = this.poliza.periodoPago ? parseInt(this.poliza.periodoPago) : 0
        this.poliza.periodoDeCobertura = this.periodoDePagoMethod(this.poliza.fechaVigencia, this.poliza.fechaFinVigencia)
      }
      self.formatMoneyMethod()

      // lowerCase info usuario
      self.usuario.nombre = self.infoUser.nombre.toLowerCase()
      self.usuario.apPaterno = self.infoUser.apPaterno.toLowerCase()
      self.usuario.apMaterno = self.infoUser.apMaterno.toLowerCase()
      let auxNombre = self.usuario.nombre.split(' ')
      self.usuario.titleName = auxNombre[0]

      // lowerCase poliza
      this.poliza.frecuenciaPago = this.poliza.frecuenciaPago.toLowerCase()

      // lowerCase coberturas
      if (self.flagIsVidacash) {
        this.poliza.coberturasCash = this.infoPoliza.coberturasCash.map(data => {
          data.nombre = data.nombre.toLowerCase()
          data.nombre = data.nombre.charAt(0).toUpperCase() + data.nombre.slice(1)

          return data
        })
      } else {
        this.poliza.coberturasVida = this.infoPoliza.coberturasVida.map(data => {
          data.nombre = data.nombre.toLowerCase()
          data.nombre = data.nombre.charAt(0).toUpperCase() + data.nombre.slice(1)

          return data
        })
      }

      self.poliza.cliente = self.usuario
      sessionStorage.setItem('infoPoliza', JSON.stringify(self.poliza))
    } else {
      self.poliza = JSON.parse(sessionStorage.getItem('infoPoliza'))
      self.usuario = self.poliza.cliente
    }
    this.consultarDocumentosEndoso(this.poliza.numeroPoliza, this.poliza.flagCesionada || 'NO')

    // SETEANDO OBJ PARA TAGGEO
    self.taggeo.tipoDocumento = self.usuario.tipoDocumento
    self.taggeo.numeroDocumento = self.usuario.numeroDocumento
    self.taggeo.numeroPoliza = self.poliza.numeroPoliza
    self.taggeo.ramo = self.poliza.ramo
    self.taggeo.producto = self.poliza.producto
    self.taggeo.nombreProducto = self.poliza.nombreProducto

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile'
      }
    })

    self.flagOpenTooltipMisSeguros = localStorage.getItem('closeTooltip') == null

    // FORMATEANDO DATOS
    let fecha = new Date()
    let fechaInicio = self.poliza.fechaVigencia.split(/[/-]/)

    if (!self.flagIsVidacash) {
      self.numeroPeriodo = Number(fecha.getFullYear()) - Number(fechaInicio[2])
      if (self.poliza.tablaValoresGarantizados && Array.isArray(self.poliza.tablaValoresGarantizados)) {
        self.periodoActual = self.poliza.tablaValoresGarantizados.filter(dato => self.numeroPeriodo + 1 === Number(dato.anho))[0]
      }
    }

    // MAYOR - MENOR A 5 AÑOS
    let inicioVigencia = self.poliza.fechaVigencia.split(/[/-]/)
    let hoy = new Date()
    let auxInicioVigencia = new Date(Number(inicioVigencia[2]), (Number(inicioVigencia[1]) - 1), Number(inicioVigencia[0]))
    self.mayor5Anhos = self.getDiferenciaAnhos(hoy, auxInicioVigencia) >= 5

    // MAYOR A 2 AÑOS
    self.mas2Anhos = self.getDiferenciaAnhos(hoy, auxInicioVigencia) >= 2

    // ANIVESARIO
    let anniversarySince = new Date(hoy.getFullYear(), Number(inicioVigencia[1]) - 1, Number(inicioVigencia[0]))
    let anniversaryUntil = new Date(hoy.getFullYear(), Number(inicioVigencia[1]) - 1, Number(inicioVigencia[0]) + 10)

    let anniversaryFlag = localStorage.getItem('anniversaryPolicyZS' + self.poliza.numeroPoliza) === 'true'
    if (anniversarySince <= new Date() && anniversaryUntil >= new Date() && !anniversaryFlag && self.numeroPeriodo > 0) {
      self.popupAlert.openPopup = true
      self.popupAlert.buttonClose = true
      self.popupAlert.image = self.iconAniversario
      self.popupAlert.title = '¡Feliz ' + ((self.numeroPeriodo > 1) ? self.numeroPeriodo + '° años juntos!' : 'Primer año juntos!')
      self.popupAlert.message = 'Hoy queremos celebrar tu compromiso con los que más amas, sigue asegurando la tranquilidad de tu familia.'
      self.popupAlert.messageButton = 'Ver historial'
      this.flagHoy = true
      localStorage.setItem('anniversaryPolicyZS' + self.poliza.numeroPoliza, true)
    }

    // CALCULO PAGO ANUAL
    this.cuotaPeriodo = this.flagIsVidacash ? Number(this.poliza.primaProgramada) : Number(this.poliza.netoPago)

    switch (this.poliza.frecuenciaPago.toLowerCase()) {
    case paymentFrequency[0].periodo:
      this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[0].pagos
      break
    case paymentFrequency[1].periodo:
      this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[1].pagos
      break
    case paymentFrequency[2].periodo:
      this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[2].pagos
      break
    case paymentFrequency[3].periodo:
      this.calculoPagoAnual = this.cuotaPeriodo * paymentFrequency[3].pagos
      break
    default:
      break
    }

    // OBTENIENDO BENEFICIARIOS
    self.getBenefits({ numeroPoliza: self.poliza.numeroPoliza })
      .then(res => {
        const callback = dato => {
          if (dato.tipoBeneficiario === 'CONTINGENTE') {
            self.beneficiariosContingentesProp.push(dato)
          } else {
            self.beneficiariosPrincipalesProp.push(dato)
          }
        }
        res.data.map(callback)
        if (res.data.length === 0) {
          (self.poliza.beneficiarios || []).map(callback)
        }
      })

    // OBTENIENDO COMPROBANTES
    // TMP: Fechas para comprobante electronico
    let auxDate = new Date()
    auxDate.setMonth(auxDate.getMonth() - 12)
    self.ce.startDate = moment(auxDate, 'DD-MM-YYYY').format('YYYY-MM')
    self.ce.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')

    const datosEventLog = {
      producto: self.poliza.nombreProducto,
      grupoProducto: self.poliza.ramo.toUpperCase(),
      numeroPoliza: self.poliza.numeroPoliza
    }
    if (this.poliza.oriProducto !== 'VIDA_CASH_PLUS') {
      self.getComprobantes({ numeroPoliza: Number(self.poliza.numeroPoliza) })
        .then(res => {
          if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length > 0)) {
            datosEventLog.documentos = res.data.documentos
            datosEventLog.Estado = 'Exitoso'
            self.listComrpobantesElectronicosActuales = res.data.documentos
            let documents = self.listComrpobantesElectronicosActuales
            let arrDocuments = []
            // SE OBTIENE LOS CODIGOS DE SUNAT DE CADA COMPROBANTE
            for (let index = 0; index < documents.length; index++) {
              arrDocuments.push(documents[index].tipoComprobante)
            }
            let arrDocsUniq = arrDocuments.filter(function (item, pos) {
              return arrDocuments.indexOf(item) === pos
            })
            // - this.items.push({ text: 'Tipo de comprobante', value: null })
            arrDocsUniq.forEach(el => {
              for (let j = 0; j < electronicVouchers.length; j++) {
                let noEncontroMatch = true
                // SE HACE MATCH
                if (electronicVouchers[j].codigoSunat === el) {
                  // DETECTAR SI YA ESTA REPETIDO DEL LEGACY
                  for (let x = 0; x < self.items.length; x++) {
                    if (self.items[x].text === electronicVouchers[j].descripcion) {
                      let newValue = self.items[x].value.split('.')
                      self.items[x].value = newValue[0] + '.' + electronicVouchers[j].codigoSunat + '.PESC'
                      noEncontroMatch = false
                      break
                    }
                  }
                  if (noEncontroMatch) {
                    self.items.push({ text: electronicVouchers[j].descripcion, value: electronicVouchers[j].codigoSunat + '.ESC' })
                    break
                  }
                }
              }
            })

            if (self.items.length === 1) {
              self.selectedTypeDoc = self.items[0].value
            }
          } else if ((res.data.codigoRespuesta === '01') && (res.data.documentos.length === 0)) {
            datosEventLog.error = res.data
            datosEventLog.statusCode = res.status
            datosEventLog.Estado = 'Vacío'
            this.$swal({
              title: 'Hola, ',
              text: 'En estos momentos, estamos trabajando en poner a disposición tu comprobante. Pero no te preocupes, en un plazo máximo de 5 días hábiles ya lo tendrás listo para la descarga.',
              confirmButtonText: 'Entendido'
            })
          } else {
            datosEventLog.Estado = 'Error'
            datosEventLog.error = res.data
            datosEventLog.statusCode = res.status
          }
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Consulta Comprobantes/Boletas',
            datos: datosEventLog
          })
        })
        .catch((err) => {
          datosEventLog.Estado = 'Error'
          datosEventLog.error = err.response
          self.eventLog({
            categoria: 'Documentos',
            nombre: 'Consulta Comprobantes/Boletas',
            datos: datosEventLog
          })
        })
    }

    this.loader.flag = false

    // CARGAR SOLICITUDES
    // CARGAR SOLICITUDES
    self.getAllRequirementsPerPolicy({ numeroPoliza: self.poliza.numeroPoliza })
      .then(data => {
        data.data.data.forEach(solicitud => {
          if (solicitud.transact.toLowerCase() === 'modificación de beneficiarios') {
            self.solicitudBeneficiarios.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'cuota comodín') {
            self.solicitudComodin.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'endoso a entidad financiera') {
            self.solicitudEndosoEntidadFinanciera.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'liberación de endoso') {
            self.solicitudLiberacionEndoso.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'anulación de poliza') {
            self.solicitudAnulacion.push(solicitud)
          } else if (solicitud.transact.toLowerCase() === 'seguimiento de solicitudes') {
            self.solicitudSeguimiento.push(solicitud)
          }
        })
      }).catch(() => {
        self.popupAlert.openPopup = true
        self.popupAlert.title = 'Estimado cliente'
        self.popupAlert.message = 'No hemos logrado obtener la información solicitada. Por favor, volver a intentarlo en unos minutos.'
        self.popupAlert.messageButton = 'Entendido'
        self.popupAlert.buttonClose = false
      })

    // this.puedeSolicitudes = (this.poliza.puedeEndosar || this.poliza.puedeCuotaComodin || this.poliza.puedeCambiarFrecuencia || this.poliza.puedeLiberarEndoso || this.poliza.puedeCambiarBeneficiario)
    this.puedeSolicitudes = (this.poliza.puedeCambiarBeneficiario)
    if (this.action) {
      this.methodView(this.action.action === 'mis solicitudes' ? 'solicitudes' : this.action.action)
      this.actionSent = true
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules']),
    flagOcultarProyeccion() {
      return true
    }
  },
  components: {
    ButtonSelect,
    IconText,
    CardNumberText,
    CardIconTextDoubleRow,
    IconTextIcon,
    DatosMisSeguros,
    PopupCoberturas,
    PopupComprobanteElectronico,
    PopupMisBeneficiarios,
    TooltipGuiaMisSeguros,
    PopupHoy,
    PopupHoyHasta5,
    PopupProyeccion,
    PopupMisSolicitudes,
    PopupDocumentosEndoso,
    PopupAniversario,
    PopupAlertMessage,
    PopupMiAgente,
    EstadoDeCuenta,
    MiAgenteMobile,
    MisCanales,
    PopupBeneficiosDesbloqueados,
    PopupMisVales
  }
}
</script>

<style scoped>
.box-buttons-centered {
  justify-content: center;
}

.box-buttons-centered > .flex {
  flex: 0 0 auto;
}

.box-buttons-centered > .flex + .flex {
  margin-left: 1em;
}

.box-open-guia-seguros {
  position: fixed;
  right: 20px;
  top: 38px;
  z-index: 1;
}

.box-open-guia-seguros .v-btn {
  height: 75px;
  width: 75px;
  margin: 0;
  background-color: #454a6cf0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/mis-seguros/MisSegurosMobile.vue